import './SwipeableTicket.less';

import clsx from 'clsx';
import { dispatch } from 'nike-re-framejs';
import React, { useContext, useState } from 'react';
import SwipeableViews from 'react-swipeable-views';

import useDelayedAction from '@/_hooks/useDelayedAction';
import { fireGAEvent } from '@/analytics';
import { CURRENT_PAGE } from 'nike-ui/src/common/routing';
import i18n from '@i18n';
import AddToTicketIcon from 'nike-ui/src/icons/svg/add-to-ticket-icon-sv.svg';
import ShareTicketIcon from 'nike-ui/src/icons/svg/share-ticket-icon-sv.svg';
import TrashIcon from '@/icons/TrashIcon';
import Ticket from '@/mytickets/components/ticket/Ticket';
import { shareTicket } from '@/mytickets/detail/views/Actions/Share';
import { deleteInLS } from '@/mytickets/saved/utils';
import { deleteTicketSaved } from '@/mytickets/saved/handlers';
import { copyTicketFromOverview } from '@/mytickets/detail/handlers';
import BetLocationContext from 'nike-ui/src/common/BetLocationContext';

function getClassName(classIndex) {
    return ['one', 'two', 'three'][classIndex] || 'one';
}

function getClassType(betStatusCounts, saved) {
    let classCounter = 0;
    if (betStatusCounts) {
        ++classCounter;
    }
    if (saved) {
        ++classCounter;
    }
    return getClassName(classCounter);
}

function SwipeableTicket({ ticket, onClick }) {
    const { betStatusCounts, customerId, hash, source } = ticket;
    const profileSaved = source === 'Saved' && customerId;
    const deviceSaved = source === 'Saved' && !customerId;
    const regBetStatusCounts = betStatusCounts?.Registered;
    const savedTicket = profileSaved || deviceSaved;
    const [visible, setVisible] = useState(true);
    const [index, setIndex] = useState(0);
    const classType = index === 1 && getClassType(regBetStatusCounts, savedTicket);
    const [, delay, cancel] = useDelayedAction(2000);
    const betLocationContext = useContext(BetLocationContext);
    const { code: positionCode, id: positionId } = betLocationContext.betLocationSection || {};

    if (!visible) {
        return null;
    }

    function deleteTicket() {
        fireGAEvent('Tikety ulozene', 'Vymazat tiket (Swipe)');

        if (profileSaved) {
            dispatch(deleteTicketSaved(ticket));
        } else {
            deleteInLS(ticket.ticketId);
        }

        setVisible(false);
    }
    function fastShareTicket(e) {
        fireGAEvent(CURRENT_PAGE, 'Zdielat (Swipe)');
        shareTicket(e, ticket);
    }
    function changeIndex(index) {
        if (index === 1) {
            setIndex(index);
            delay(() => setIndex(0));
        } else {
            setIndex(0);
            cancel();
        }
    }
    return (
        <SwipeableViews
            className={clsx('swipeable-ticket', classType)}
            slideClassName="swipeable-ticket-slide"
            disableLazyLoading
            index={index}
            hysteresis={0.1}
            onChangeIndex={index => changeIndex(index)}
        >
            <Ticket ticket={ticket} onClick={onClick} />
            <div className="swipable-items">
                {regBetStatusCounts ? (
                    <SwipeableItem
                        icon={AddToTicketIcon}
                        text={i18n('ticket.options.newTicket')}
                        onClick={() => dispatch(copyTicketFromOverview(hash, positionCode, positionId))}
                    />
                ) : null}
                <SwipeableItem
                    icon={ShareTicketIcon}
                    text={i18n('tiket.detailTiketu.share')}
                    onClick={e => fastShareTicket(e)}
                />
                {savedTicket ? (
                    <SwipeableItem
                        className="delete"
                        icon={TrashIcon}
                        text={i18n('ticket.options.delete')}
                        onClick={deleteTicket}
                    />
                ) : null}
            </div>
        </SwipeableViews>
    );
}

function SwipeableItem({ onClick, text, className, icon: Icon }) {
    return (
        <div className="swipeable-item" onClick={onClick}>
            <Icon />
            <div className={clsx('text', className)}>{text}</div>
        </div>
    );
}

export default SwipeableTicket;
